/**
 * Upload System Configuration
 *
 * Toggle between old and new upload systems by changing USE_NEW_UPLOAD_SYSTEM
 */

export const UPLOAD_CONFIG = {
  // Feature flag: Set to true to use new upload system, false for legacy
  USE_NEW_UPLOAD_SYSTEM: true,

  // Upload settings
  CHUNK_SIZE: 5 * 1024 * 1024, // 5MB minimum for S3 multipart
  MAX_CONCURRENT_UPLOADS: 3,
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 2000, // 2 seconds

  // Progress update settings
  PROGRESS_UPDATE_INTERVAL: 200, // Update UI every 200ms for smooth progress (in milliseconds)
  SPEED_UPDATE_INTERVAL: 1500, // Update speed/ETA every 1.5 seconds for stable display (in milliseconds)

  // Network detection
  NETWORK_CHECK_INTERVAL: 5000, // 5 seconds
  NETWORK_CHECK_URL: 'https://www.google.com/favicon.ico',

  // UI settings
  SHOW_UPLOAD_PANEL: true,
  PANEL_POSITION: 'bottom-right', // 'bottom-right', 'bottom-left', 'top-right', 'top-left'
  AUTO_HIDE_COMPLETED: true,
  AUTO_HIDE_DELAY: 5000, // 5 seconds
};

export default UPLOAD_CONFIG;
